import React from "react"
import RelationshipSimple from "./RelationshipSimple";
import RelationshipCar from "../../../mtska-frontend-modules/modules/Car/views/RelationshipCar";
import RelationshipSetup from "./RelationshipSetup";
import RelationshipFileGeneric from "./RelationshipFileGeneric";
import RelationshipPerson from './RelationshipPerson';
import RelationshipEmployment from './RelationshipEmployment';
import RelationshipEmployments from './RelationshipEmployments';
import RelationshipEmploymentsWithPerson from './RelationshipEmploymentsWithPerson';
import RelationshipDriverDelegate from "./RelationshipDriverDelegate";
import RelationshipService from "./RelationshipService";
import RelationshipLegalEntity from "./RelationshipLegalEntity";
import RelationshipTraceKm from "./RelationshipTraceKm";
import RelationshipTyreSet from "./RelationshipTyreSet";
import RelationshipContract from "../../../mtska-frontend-modules/modules/Contract/views/RelationshipContract";
import RelationshipPool from "./RelationshipPool";
import RelationshipFringeBenefitCar from "./RelationshipFringeBenefitCar";
import RelationshipFringeBenefitValue from "./RelationshipFringeBenefitValue";
import RelationshipAttributionRule from "./RelationshipAttributionRule";
import RelationshipCashFlowRecordGroup from "./RelationshipCashFlowRecordGroup";
import RelationshipContoEconomicoRecordGroup from "./RelationshipContoEconomicoRecordGroup";
import RelationshipContoEconomicoRecord from "./RelationshipContoEconomicoRecord";
import RelationshipCarCalendar from "./RelationshipCarCalendar";

import { Checkbox, List, ListItem, ListItemContent } from "@mui/joy";
import { useTranslation } from 'react-i18next'
import RelationshipSaltEdgeAccount from "./RelationshipSaltEdgeAccount";
import RelationshipSaltEdgeConnection from "./RelationshipSaltEdgeConnection";

const Relationship = ({ view = 'simple', value, editing, visiblelimit, handleItemDetail, handleItemRemove, relation, callback, setValue, checkable, checked, onCheckChange, loadingDissociation }) => {
    const { t, i18n } = useTranslation();

    const getItem = (v, k) => {
        let item;
        switch (view) {
            case 'car':
                item = <RelationshipCar
                    k={k}
                    v={v}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                />
                break;
            case 'carcalendar':
                item = <RelationshipCarCalendar
                    k={k}
                    v={v}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                />
                break;
            case 'setup':
                item = <RelationshipSetup
                    k={k}
                    v={v}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                />
                break;
            case 'fringebenefitcar':
                item = <RelationshipFringeBenefitCar
                    k={k}
                    v={v}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                />
                break;
            case 'fringebenefitvalue':
                item = <RelationshipFringeBenefitValue
                    k={k}
                    v={v}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                />
                break;
            case 'contract':
                item = <RelationshipContract
                    k={k}
                    v={v}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                />
                break;
            case 'pool':
                item = <RelationshipPool
                    k={k}
                    v={v}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                />
                break;
            case 'legalEntity':
                item = <RelationshipLegalEntity
                    k={k}
                    v={v}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                />
                break;
            case 'fileGeneric':
            case 'document':
            case 'documents':
            case 'picture':
                item = <RelationshipFileGeneric
                    k={k}
                    v={v}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                />
                break;
            case 'driverdelegate':
                item = <RelationshipDriverDelegate
                    k={k}
                    v={v}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                />
                break;
            case 'service':
                item = <RelationshipService
                    k={k}
                    v={v}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                />
                break;
            case 'person':
                item = <RelationshipPerson
                    callback={callback}
                    filters={value}
                    relation={relation}
                    k={k}
                    v={v}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                />
                break;
            case 'employment':
                item = <RelationshipEmployment
                    callback={callback}
                    filters={value}
                    relation={relation}
                    k={k}
                    v={v}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                    setValue={setValue}
                />
                break;
            case 'employments':
                item = <RelationshipEmployments
                    callback={callback}
                    filters={value}
                    relation={relation}
                    k={k}
                    v={v}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                />
                break;
            case 'employmentsWithPerson':
                item = <RelationshipEmploymentsWithPerson
                    callback={callback}
                    filters={value}
                    relation={relation}
                    k={k}
                    v={v}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                />
                break;
            case 'traceKm':
            case 'traceKms':
                item = <RelationshipTraceKm
                    k={k}
                    v={v}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                />
                break;
            case 'tyreSet':
                item = <RelationshipTyreSet
                    k={k}
                    v={v}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                />
                break;
            case 'saltedgeconnection':
                item = <RelationshipSaltEdgeConnection
                    k={k}
                    v={v}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                />
                break;
            case 'saltedgeaccount':
                item = <RelationshipSaltEdgeAccount
                    k={k}
                    v={v}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                />
                break;
            case 'attributionrule':
                item = <RelationshipAttributionRule
                    k={k}
                    v={v}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                />
                break;
            case 'contoeconomicorecordgroup':
                item = <RelationshipContoEconomicoRecordGroup
                    k={k}
                    v={v}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                />
                break;
            case 'contoeconomicorecord':
                item = <RelationshipContoEconomicoRecord
                    k={k}
                    v={v}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                />
                break;
            case 'cashflowrecordgroup':
                item = <RelationshipCashFlowRecordGroup
                    k={k}
                    v={v}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                />
            default:
                item = <RelationshipSimple
                    k={k}
                    v={v}
                    view={view}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                />
        }

        if (checkable) {
            return <ListItem sx={{display:'grid', gridTemplateColumns:'30px auto'}} className="relationship-checkable"><Checkbox onChange={onCheckChange} value={v._id}/>{item}</ListItem>
        } else {
            return item;
        }
    }


    let items;
    if (Array.isArray(value)) {
        items = value.map((v, k) => {
            if (k >= visiblelimit) return;
            return getItem(v, k);
        })
    } else if (typeof value === 'object' && value !== null) {
        items = getItem(value, 1);
    }

    return (
        <List variant="plain" className={"relationship-elements relationship-elements-" + view}>
            {/* <textarea>{JSON.stringify(value)}</textarea> */}
            { items }
            
            {(!editing && !items) && (
                <ListItem variant="plain">
                    <ListItemContent >{t('none')}</ListItemContent>
                </ListItem>
            )}
        </List>
    );
};

export default Relationship
